webpackJsonp([263791100135453],{

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage() {
	  return _react2.default.createElement(
	    "div",
	    { className: "about-page section" },
	    _react2.default.createElement(
	      "div",
	      { className: "columns is-multiline is-centered" },
	      _react2.default.createElement(
	        "div",
	        { className: "column is-half" },
	        _react2.default.createElement("img", { src: "https://res.cloudinary.com/zackhave/image/upload/cindy-sherry/cindy_bw.jpg", className: "about-image" })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "column is-half" },
	        _react2.default.createElement(
	          "h1",
	          { className: "title is-4" },
	          "About Cindy"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Cindy Sherry is an artist residing in Nelson, British Columbia. Her work, over three decades, has informed a unique artistic vision intent on capturing the fragility and beauty in the world and on challenging viewers to see and appreciate what we often take for granted."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Sherry\u2019s art has been described as \u2018uplifting and playful in voice, asking the viewer to discover layered views of interpretation. It can evoke happiness or it can demonstrate a satirical opinion while considering humanity\u2019s compromising place in nature.\u2019"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "The galleries on this site contain paintings from two series; \u2018Garden Gnomes\u2019 and \u2018At One With Nature\u2019. Both bodies of work address themes in the artist\u2019s loose, energetic, colourful style."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Sherry earned her B.F.A. from Queen\u2019s University in Kingston, Ontario, where she was a finalist in the RBC Bank\u2019s \u2018Art Venture\u2019 competition. Her paintings and drawings have been exhibited in Quebec, Ontario, and British Columbia. They have a place with collections in Canada, England, The United States, and Japan."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "column is-one-third" },
	        _react2.default.createElement(
	          "a",
	          { href: "/#gallery-1" },
	          _react2.default.createElement("img", { src: "https://res.cloudinary.com/zackhave/image/upload/cindy-sherry/Cindy_s_art_-_30x40_-_Just_the_Bee_s_Knees_-_FX87902.jpg" })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "column is-one-third" },
	        _react2.default.createElement(
	          "a",
	          { href: "/#gallery-2" },
	          _react2.default.createElement("img", { src: "https://res.cloudinary.com/zackhave/image/upload/cindy-sherry/Cindy_s_art_-_30x40_-_Tossing_Rocks_-_FX87905.jpg" })
	        )
	      )
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-68561174fafde7c53da7.js